<div class="modal-header">
  <div class="mx-auto"><img class="brand-logo-img" src="assets/img/zynyo-logo.svg" alt="Zynyo Logo" /></div>
</div>
<div class="modal-body">
  @if (onboardingModals) {
    <ngb-carousel [showNavigationArrows]="false" #ngbCarousel="ngbCarousel" (slide)="onSlide($event)" wrap="false">
      @for (onboardingModal of onboardingModals; track onboardingModal) {
        <ng-template ngbSlide >
          <div class="text-center icon" id="{{onboardingModal.id}}">
            <em [class]="onboardingModal.icon"></em>
          </div>
          <div class="content">
            <h1 class="text-md text-primary">{{onboardingModal.title}}</h1>
            <p [innerHTML]="onboardingModal.content"></p>
            @if (onboardingModal.btn) {
              <div class="text-center">
                <button class="btn btn-sm btn-secondary mt-3" (click)="routeToLink()">{{onboardingModal.btn}}</button>
              </div>
            }
          </div>
        </ng-template>
      }
    </ngb-carousel>
  }

  <div class="onboarding-nav">
    @if (displayNav) {
      <div class="nav-btns" >
        <div class="float-left">
          <a class="btn" (click)="skip()">Overslaan</a>
        </div>
        <div class="float-right">
          <a class="btn" (click)="ngbCarousel.next()">Volgende</a>
        </div>
      </div>
    }
  </div>
</div>
